import { supabase } from '@/lib/supabase';

const API_BASE = '/api/ai';

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const aiAssistantService = {
  async getStatus() {
    try {
      const headers = await authHeaders();
      const r = await fetch(`${API_BASE}/status`, { headers });
      if (!r.ok) return { ok: false, error: `HTTP ${r.status}` };
      return { ok: true, data: await r.json() };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  },

  async listConversations() {
    try {
      const headers = await authHeaders();
      const r = await fetch(`${API_BASE}/conversations`, { headers });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        return { ok: false, error: err.error || `HTTP ${r.status}` };
      }
      const data = await r.json();
      return { ok: true, data: data.conversations || [] };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  },

  async getMessages(conversationId) {
    try {
      const headers = await authHeaders();
      const r = await fetch(
        `${API_BASE}/conversations/${conversationId}/messages`,
        { headers }
      );
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        return { ok: false, error: err.error || `HTTP ${r.status}` };
      }
      const data = await r.json();
      return { ok: true, data: data.messages || [] };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  },

  async deleteConversation(conversationId) {
    try {
      const headers = await authHeaders();
      const r = await fetch(`${API_BASE}/conversations/${conversationId}`, {
        method: 'DELETE',
        headers,
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        return { ok: false, error: err.error || `HTTP ${r.status}` };
      }
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  },

  async sendMessage({ message, conversationId, pdfContext }) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...(await authHeaders()),
      };
      const r = await fetch(`${API_BASE}/chat`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ message, conversationId, pdfContext }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) {
        return { ok: false, error: data.error || `HTTP ${r.status}` };
      }
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  },

  async uploadPdf(file) {
    try {
      const headers = await authHeaders();
      const fd = new FormData();
      fd.append('file', file);
      const r = await fetch(`${API_BASE}/upload-pdf`, {
        method: 'POST',
        headers,
        body: fd,
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) {
        return { ok: false, error: data.error || `HTTP ${r.status}` };
      }
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: e.message };
    }
  },
};
